module.exports = __webpack_public_path__ + "static/media/bicycles_hero_tablet.646a9e54.jpg";